'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader

const actions = {
  getCalendarHoliday(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/holiday/findbycompanyid`
        const result = await axios.get(url, {
          ...costumHeader('Get Calendar Holiday', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  saveCalendarHoliday(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/holiday/add`
        const result = await axios.post(url, body, costumHeader('Save Calendar Holiday', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editCalendarEdit(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/holiday/edit`
        const result = await axios.post(url, body, costumHeader('Edit Calendar Holiday', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteCalendarHoliday(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/holiday/delete`
        const result = await axios.post(url, body, costumHeader('Delete Calendar Holiday', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  }
}

export default { actions }